import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type SectionElement = 'section' | 'div';

/**
 * Shared page-section wrapper: optional id, outer surface classes, and inner container.
 */
export function SectionLayout({
  id,
  as = 'section',
  className,
  containerClassName,
  children,
}: {
  id?: string;
  as?: SectionElement;
  className?: string;
  /** When set, wraps `children` in a horizontal container (e.g. `mx-auto max-w-7xl`). */
  containerClassName?: string;
  children: ReactNode;
}) {
  const Tag = as;

  return (
    <Tag id={id} className={className}>
      {containerClassName ? <div className={cn(containerClassName)}>{children}</div> : children}
    </Tag>
  );
}
